import useMutation from 'use-mutation'
import { post } from './api'
import { HTTPError } from './HTTPError'
import { NewUser, User, UpdatePassword } from './types'

type CreateUserArgs = { user: NewUser }
const createUser = ({ user }: CreateUserArgs) => post<User>('/users', user)

export const useCreateUser = () =>
  useMutation<CreateUserArgs, User, HTTPError>(createUser)

type ActivateUserArgs = { token: string }
const activateUser = (params: ActivateUserArgs) =>
  post<null>('/users/activate', params)

export const useActivateUser = () =>
  useMutation<ActivateUserArgs, null, HTTPError>(activateUser)

type ResetPasswordArgs = { email: string }
const resetPassword = (params: ResetPasswordArgs) =>
  post<null>('/users/password-reset', params)

export const useResetPassword = () =>
  useMutation<ResetPasswordArgs, null, HTTPError>(resetPassword)

type UpdatePasswordArgs = { userId: string; params: UpdatePassword }
const updatePassword = ({ userId, params }: UpdatePasswordArgs) =>
  post<null>(`/users/${userId}/password-update`, params)

export const useUpdatePassword = () =>
  useMutation<UpdatePasswordArgs, null, HTTPError>(updatePassword)
